import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { setLoginReturn, setFirstLoginReturn, hotAddUser, getUserData } from '../../../../redux/actions';
import { generateTestId } from '../../../../app/functions';
import LoginRegistration from './LoginRegistration';
import RegistrationForm from './RegistrationForm';

const LoginManager = (props) => {
    const { testID = 'login-manager', onOtpStateChange, renderPhoneValidationExternally, onOtpRequest, onRegistrationResponse, onCloseAllModals } = props;
    const [step, updateStep] = useState({ before: 1, after: 1, processType: 'None' });
    
    const handleStepUp = (newStep) => {
        updateStep(newStep);
    };

    useEffect(() => {
        return () => {
            props.setFirstLoginReturn(false);
            props.setLoginReturn(false);
            updateStep({ before: 1, after: 1, processType: 'None' });
        }
    }, []);

    const getStep = () => {
        switch (step.after) {
            case 1:
                return (
                    <LoginRegistration
                        stepUp={handleStepUp}
                        subtitleText={props.subtitleText}
                        loginFormName={props.loginFormName}
                        onLogin={props.onLogin}
                        testID={generateTestId(testID, 'login-registration')}
                    />
                );
            case 2:
                return (
                    <RegistrationForm
                        text={props.text}
                        onOtpStateChange={onOtpStateChange}
                        testID={generateTestId(testID, 'registration-form')}
                        renderPhoneValidationExternally={renderPhoneValidationExternally}
                        onOtpRequest={onOtpRequest}
                        onRegistrationResponse={onRegistrationResponse}
                        onCloseAllModals={onCloseAllModals}
                    />
                );
            default:
                return null;
        }
    };

    return getStep();
};

const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.Translations,
        firstLogin: store.config.FirstLoginReturn
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setLoginReturn: (payload) => dispatch(setLoginReturn(payload)),
        setFirstLoginReturn: (payload) => dispatch(setFirstLoginReturn(payload)),
        hotAddUser: (payload) => dispatch(hotAddUser(payload)),
        register: (payload) => dispatch(hotAddUser(payload)),
        getUserData: () => dispatch(getUserData()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(LoginManager);